// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"BreadCrumbs_breadcrumbs__sgga_"};